import React, { useEffect, useReducer, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import WOW from 'wowjs';
import { SRLWrapper } from "simple-react-lightbox";
import { NavLink } from "react-router-dom";
import AnimatedCursor from "react-animated-cursor";


/*---------Using reducer mange the active or inactive menu----------*/
const initialState = { activeMenu: '' };

function reducer(state, action) {
  switch (action.type) {
    case 'homeOne':
      return { activeMenu: 'homeOne' };
      case 'solution':
        return { activeMenu: 'service' };
    case 'service':
      return { activeMenu: 'service' };
    case 'projects':
      return { activeMenu: 'projects' };
    case 'pages':
      return { activeMenu: 'pages' };
    case 'blogs':
      return { activeMenu: 'blogs' };
    default:
      return { activeMenu: '' };
  }
}

function Header() {
  const [state, dispatch] = useReducer(reducer, initialState);
  const currentRoute = useLocation().pathname

  // Sticky Navbar
  useEffect(() => {
    new WOW.WOW({
      live: false
    }).init();
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });
  const isSticky = (e) => {
    const header = document.querySelector(".header-section");
    const menuscrollTop = window.scrollY;
    menuscrollTop >= 20
      ? header.classList.add("sticky")
      : header.classList.remove("sticky");
  };

  /*----for single sidebar event use one state-------*/
  const [sidebar, setSidebar] = useState(false);
  const [sidebarleft, setSidebarleft] = useState(false);
  const [searchBar, setSearchBar] = useState(false);
  const handleSearchbar = () => {
    if (searchBar === false || searchBar === 0) {
      setSearchBar(1);
    } else {
      setSearchBar(false);
    }
  }
  const showSidebar = () => {
    if (sidebar === false || sidebar === 0) {
      setSidebar(1);
    } else {
      setSidebar(false);
    }
  };
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" })
  const showSidebarleft = () => {
    if (sidebarleft === false || sidebarleft === 0) {
      setSidebarleft(1);
    } else {
      setSidebarleft(false);
    }
  };

  return (
    <>
      {/* <AnimatedCursor
        className="coursor"
        innerSize={8}
        outerSize={30}
        color="230, 230, 230"
        outerAlpha={0.5}
        innerScale={0.7}
        outerScale={1.5}
        zIndex="99999"
        clickables={[
          "a",
          "i",
          'input[type="text"]',
          'input[type="email"]',
          'input[type="number"]',
          'input[type="submit"]',
          'input[type="image"]',
          "label[for]",
          "select",
          "textarea",
          "button",
          ".link",
          ".sub-menu",
          ".has-child",
          ".menu-toggle-wrap",
          ".search-cross-btn",
          ".SRLControls",
        ]}
      /> */}

      <div className={sidebarleft === 1 ? "menu-toggle-btn-full-shape show-sidebar" : "menu-toggle-btn-full-shape"}>
        <div className="menu-toggle-wrap bg-white">
          <div className="sidebar-top-area">
            <div onClick={showSidebarleft} className="cross-icon">
              <i className="bx bx-x" />
            </div>
            <div className="sidebar-logo">
              <Link onClick={scrollTop} to={"/"}><img src={process.env.PUBLIC_URL + "/images/icon/Frame 11 (1).svg"} alt="images" /></Link>
            </div>
            <p>A company with a team of experienced developers and project managers, We pride ourselves on delivering top-notch work for our clients.</p>
          </div>
          <div className="sidebar-body">
            <h3 className="sidebar-title">Instagram Post</h3>
            <SRLWrapper>
              <div className="sidebar-gallery">
                <ul className="gallery">
               
                            <li>
                              <a
                                href={
                                  process.env.PUBLIC_URL +
                                  "#"
                                }
                                className="image-open"
                              >
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "https://scontent.flhe7-1.fna.fbcdn.net/v/t39.30808-6/302245916_601034841599023_7161945652848613386_n.jpg?_nc_cat=104&ccb=1-7&_nc_sid=a26aad&_nc_eui2=AeGgkaOYskSFAZ9SVxeHy1Ju2NvGjovZ-DDY28aOi9n4MHNVdJyMr4XF7EugqH4-SZN1E3mOYTfhRH8ajI0pyCDf&_nc_ohc=D9fQ6R8-BRgAX-qKDee&_nc_ht=scontent.flhe7-1.fna&oh=00_AfAfxkMOAqKcbx14SYb1NmeSrY6p0g8ZbepFcZXckkkFUQ&oe=640F6DEB"
                                  }
                                  alt="images"
                                />
                              </a>
                            </li>




                            <li>
                              <a
                                href={
                                  process.env.PUBLIC_URL +
                                  "#"
                                }
                                className="image-open"
                              >
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "https://scontent.flhe3-1.fna.fbcdn.net/v/t39.30808-6/312981625_481180887361594_7050268605438667892_n.jpg?_nc_cat=100&ccb=1-7&_nc_sid=730e14&_nc_eui2=AeEY0cyt2q1kmWG3_lz3Lps_chr6Ctjir_pyGvoK2OKv-rxdmoME-DkNyhaCyTjHNJu2UYgPJIY5hDlIjbY8imVL&_nc_ohc=h7qTtkoeahoAX8ASHhX&_nc_ht=scontent.flhe3-1.fna&oh=00_AfDfIQ0zuHiQ7eftQHvUgWN1a6lN_WOwx2v5OY-T0bm1KQ&oe=64104868"
                                  }
                                  alt="images"
                                />
                              </a>
                            </li>



                            <li>
                              <a
                                href={
                                  process.env.PUBLIC_URL +
                                  "#"
                                }
                                className="image-open"
                              >
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "https://scontent.flhe3-1.fna.fbcdn.net/v/t39.30808-6/325205532_1379852586092211_5754924342702929662_n.jpg?_nc_cat=101&ccb=1-7&_nc_sid=730e14&_nc_eui2=AeH9dqM8dpkQ8IbVvsf3uTnJDQrQ2mXp1nINCtDaZenWckOibxoq7dp_1kjnyhQGI9z82SEr0sAkDsxfzJ-aNyeG&_nc_ohc=5II5rWPpXzYAX-f9VIU&_nc_ht=scontent.flhe3-1.fna&oh=00_AfCDTDhyaDTvDF5wycEhe3Yywov7UpBB8iNXPMKkG-pJKQ&oe=64104F97"
                                  }
                                  alt="images"
                                />
                              </a>
                            </li>


                            <li>
                              <a
                                href={
                                  process.env.PUBLIC_URL +
                                  "#"
                                }
                                className="image-open"
                              >
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "https://scontent.flhe3-1.fna.fbcdn.net/v/t39.30808-6/309379975_457695089710174_45463101037477502_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=19026a&_nc_eui2=AeH16amLNcBEqeBnYxgEcbQQyhvpIsirPfXKG-kiyKs99WDeYwNy9Wc7dxGlIicz4iv7urDmVgS643WYYe9pm6cc&_nc_ohc=MNHFyim-0sUAX8pau0p&_nc_ht=scontent.flhe3-1.fna&oh=00_AfD8LSL6Rno_sL-oKapz6NU4paEOWFqMsosKBDfOSGyjqQ&oe=640FCA60"
                                  }
                                  alt="images"
                                />
                              </a>
                            </li>

                            <li>
                              <a
                                href={
                                  process.env.PUBLIC_URL +
                                  "#"
                                }
                                className="image-open"
                              >
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "https://scontent.flhe3-1.fna.fbcdn.net/v/t39.30808-6/256444485_417605366608639_6568388155633485271_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=730e14&_nc_eui2=AeELi3cVKIYagAhyu99WF5e_dL-YHsG8gbx0v5gewbyBvOVa4NXpr4-G77W3kCrwu_k9fkZ-ssum1kr4NNWY1R8A&_nc_ohc=VExh7U4ygNcAX_F5SSv&_nc_ht=scontent.flhe3-1.fna&oh=00_AfByC4XRnrMcy63dAPkDT8TNc5rgiJVTRYVSAInJwQ9sQA&oe=64112B8C"
                                  }
                                  alt="images"
                                />
                              </a>
                            </li>



                            <li>
                              <a
                                href={
                                  process.env.PUBLIC_URL +
                                  "#"
                                }
                                className="image-open"
                              >
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    "https://scontent.flhe3-1.fna.fbcdn.net/v/t39.30808-6/325214195_560835335928890_4279631600196229413_n.jpg?_nc_cat=101&ccb=1-7&_nc_sid=8bfeb9&_nc_eui2=AeE6j8aU-Gn6ZWYlZPaEx0dM1ePdOllajAfV4906WVqMB6PrWBIFfdLLvKUaPGalgqUgt19wFTPAxjHBR7002JMl&_nc_ohc=VYdmw9TwqkMAX-hIVqg&_nc_ht=scontent.flhe3-1.fna&oh=00_AfAhvOLj3fHTWIdXg5uWfVE2-Ndub-qDopl9nZYe3pXy9Q&oe=6411156B"
                                  }
                                  alt="images"
                                />
                              </a>
                            </li>






                </ul>
              </div>
            </SRLWrapper>
          </div>
          <div className="sidebar-bottom">
            <h3 className="sidebar-title">Join Our Community</h3>
            <ul className="sidebar-social-list">
              <li><a rel="noopener noreferrer" href="https://twitter.com/Geniusfixers" target="_blank"><i className="bx bxl-twitter" /></a></li>
              <li><a rel="noopener noreferrer" href="https://www.facebook.com/" target="_blank"><i className="bx bxl-facebook" /></a></li>
              <li><a rel="noopener noreferrer" href="https://www.pinterest.com/" target="_blank"><i className="bx bxl-pinterest-alt" /></a></li>
              <li><a rel="noopener noreferrer" href="https://www.linkedin.com/company/89312628/admin/" target="_blank"><i className="bx bxl-instagram" /></a></li>
              {/* <li><a rel="noopener noreferrer" href="https://www.dribbble.com/" target="_blank"><i className="bx bxl-inlinked" /></a></li> */}
            </ul>
            <div className="copyright">Copyright 2023 <Link onClick={scrollTop} to={"#"}>Genius Fixers</Link> | Genius Fixers LLC </div>
          </div>
        </div>
      </div>
      <div className={searchBar === 1 ? "mobile-search slide" : "mobile-search"}>
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-11">
              <label>What are you lookking for?</label>
              <input type="text" placeholder="Search Projects, Services, Blog" />
            </div>
            <div className="col-1 d-flex justify-content-end align-items-center">
              <div onClick={handleSearchbar} className="search-cross-btn">
                {/* <i class="bi bi-search me-4"></i> */}
                <i className="bi bi-x" />
              </div>
            </div>
          </div>
        </div>
      </div>


      <header className="header-section">
        <div className="container-fluid">
          <div className="header-area">
            <div className="header-logo">
              <Link onClick={scrollTop} to={"#"}>
                <img src={process.env.PUBLIC_URL + "/images/icon/Frame 11 (1).svg"} height="40" alt="images" />
              </Link>
            </div>
            <div className="mobile-menu-btn text-white d-lg-none d-block">
              <i onClick={showSidebar} className="bi bi-list" />
            </div>
            <div className={sidebar === 1 ? "main-menu show-menu" : "main-menu"} >
              <div className="mobile-logo-area d-lg-none d-block">
                <div className="mobile-logo-wrap d-flex justify-content-between align-items-center">
                  <img src={process.env.PUBLIC_URL + "/images/icon/Frame 11 (1).svg"} alt="images" />
                  <div className="menu-close-btn" onClick={showSidebar}>
                    <i className="bi bi-x-lg" />
                  </div>
                </div>
              </div>
              <ul className="menu-list">

                <li className={currentRoute === "/" ? "menu-item active" : "menu-item"} onClick={() => dispatch({ type: 'homeOne' })} >
                  <Link onClick={scrollTop} to={`${process.env.PUBLIC_URL}/`} className="menu-link drop-down cusm-front" >
                    Home

                  </Link>

                </li>
              {/* Solution Section Start//////////////////////////////////////////////////////////////// */}
                <li className={currentRoute === "/solution" ? "menu-item active" : "menu-item"} onClick={() => dispatch({ type: 'solution' })} >
                  <Link to={"/solution"} className="menu-link drop-down" >
                    Solution
                    {/* <i className="bx bx-chevron-down dropdown-icon" /> */}
                  </Link>
                  {/* <ul className={
                    state.activeMenu === 'solution'
                      ? "submenu d-block"
                      : "submenu d-xl-block d-none"
                  }>
                    <li className={currentRoute === "/mobile-app-development" ? "sub-item active" : "sub-item"}>
                      <Link className="cusm-front" onClick={scrollTop} to={`${process.env.PUBLIC_URL}/mobile-app-development`}>Mobile App Development </Link>
                    </li>

                    <li className={currentRoute === "/web-app-development " ? "sub-item active" : "sub-item"}>
                      <Link className="cusm-front" onClick={scrollTop} to={`${process.env.PUBLIC_URL}/web-app-development`}>Web App Development </Link>
                    </li>
                    <li className={currentRoute === "/web-app-development " ? "sub-item active" : "sub-item"}>
                      <Link className="cusm-front" onClick={scrollTop} to={`${process.env.PUBLIC_URL}/web-app-development`}>Block Chain Development  </Link>
                    </li>
                    <li className={currentRoute === "/web-app-development " ? "sub-item active" : "sub-item"}>
                      <Link className="cusm-front" onClick={scrollTop} to={`${process.env.PUBLIC_URL}/web-app-development`}>SaaS Development  </Link>
                    </li>
                    <li className={currentRoute === "/web-app-development " ? "sub-item active" : "sub-item"}>
                      <Link className="cusm-front" onClick={scrollTop} to={`${process.env.PUBLIC_URL}/web-app-development`}>Robotic Process Automation (RPA)  </Link>
                    </li>
                    <li className={currentRoute === "/web-app-development " ? "sub-item active" : "sub-item"}>
                      <Link className="cusm-front" onClick={scrollTop} to={`${process.env.PUBLIC_URL}/web-app-development`}>Live Video Streaming App  </Link>
                    </li>
                    <li className={currentRoute === "/web-app-development " ? "sub-item active" : "sub-item"}>
                      <Link className="cusm-front" onClick={scrollTop} to={`${process.env.PUBLIC_URL}/web-app-development`}>Cloud Consulting  </Link>
                    </li>
                    <li className={currentRoute === "/web-app-development " ? "sub-item active" : "sub-item"}>
                      <Link className="cusm-front" onClick={scrollTop} to={`${process.env.PUBLIC_URL}/web-app-development`}>IoT App Development  </Link>
                    </li>
                    <li className={currentRoute === "/web-app-development " ? "sub-item active" : "sub-item"}>
                      <Link className="cusm-front" onClick={scrollTop} to={`${process.env.PUBLIC_URL}/web-app-development`}>Data Science Consulting  </Link>
                    </li>
                    <li className={currentRoute === "/web-app-development " ? "sub-item active" : "sub-item"}>
                      <Link className="cusm-front" onClick={scrollTop} to={`${process.env.PUBLIC_URL}/web-app-development`}>Virtual Reality Development   </Link>
                    </li>
                    <li className={currentRoute === "/web-app-development " ? "sub-item active" : "sub-item"}>
                      <Link className="cusm-front" onClick={scrollTop} to={`${process.env.PUBLIC_URL}/web-app-development`}>SQA Software Quality Assurance   </Link>
                    </li>


                  </ul> */}
                </li>



                {/* Services */}
                <li className={currentRoute === "/service" || currentRoute === "/service-details" ? "menu-item active" : "menu-item"} onClick={() => dispatch({ type: 'service' })}>
                  <Link to={"/service"} className="menu-link drop-down">
                    services
                    {/* <i className="bx bx-chevron-down dropdown-icon" /> */}
                  </Link>
                  {/* <ul className={
                    state.activeMenu === 'service'
                      ? "submenu d-block"
                      : "submenu d-xl-block d-none"
                  }>
                    <li className={currentRoute === "/service" ? "sub-item active" : "sub-item"}>
                      <Link to={`${process.env.PUBLIC_URL}/service`} onClick={scrollTop}>Bluetooth (BLE) App Development </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link to={`${process.env.PUBLIC_URL}/service-details`} onClick={scrollTop}>DevOps Services </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link to={`${process.env.PUBLIC_URL}/service-details`} onClick={scrollTop}>Software Product Engineering  </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link to={`${process.env.PUBLIC_URL}/service-details`} onClick={scrollTop}>Offshore Software Development   </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link to={`${process.env.PUBLIC_URL}/service-details`} onClick={scrollTop}>Digital Transformation Services  </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link to={`${process.env.PUBLIC_URL}/service-details`} onClick={scrollTop}>IT Staff Augmentation/ Managed     </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link to={`${process.env.PUBLIC_URL}/service-details`} onClick={scrollTop}>E-Commerce Market Place Development   </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link to={`${process.env.PUBLIC_URL}/service-details`} onClick={scrollTop}>UI/UX and Graphics   </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link to={`${process.env.PUBLIC_URL}/service-details`} onClick={scrollTop}>Virtual CTO  </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link to={`${process.env.PUBLIC_URL}/service-details`} onClick={scrollTop}>Digital Marketing & SEO   </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link to={`${process.env.PUBLIC_URL}/service-details`} onClick={scrollTop}>Google Ads & Facebook Ads  </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link to={`${process.env.PUBLIC_URL}/service-details`} onClick={scrollTop}>Web Scrapping   </Link>
                    </li>
                  </ul> */}
                </li>


                {/* Technlogies */}
                <li className={currentRoute === "/Technlogies" || currentRoute === "/service-details" ? "menu-item active" : "menu-item"} onClick={() => dispatch({ type: '' })}>
                  <Link to={"#"} className="menu-link drop-down">
                    Technology
                    <i className="bx bx-chevron-down dropdown-icon" />
                  </Link>
                  <ul style={{width:"500px"}} className={
                    state.activeMenu === 'Technlogies'
                      ? "submenu submenu-tch d-block"
                      : "submenu submenu-tch d-xl-block d-none"
                  }>
                    <div  className="row pt-3">
                      <div className="col-4">
                      <li className={currentRoute === "/service" ? "sub-item active" : "sub-item"}>
                      <Link to={`${process.env.PUBLIC_URL}/service`} onClick={scrollTop}>Backend Technologies</Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link style={{border:"none"}} to={`#`} onClick={scrollTop}><span><img style={{height:"25px", width:'25px', marginRight:'5px',}} src="/images/icon/python.png" alt="" /></span>Python</Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link style={{border:"none"}} to={`#`} onClick={scrollTop}><span><img style={{height:"25px", width:'25px', marginRight:'5px',}} src="/images/icon/MicrosoftTeams-image (1300).png" alt="" /></span>  Php </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link style={{border:"none"}} to={`#`} onClick={scrollTop}><span><img style={{height:"25px", width:'25px', marginRight:'5px',}} src="/images/icon/Node.svg" alt="" /></span>  Node JS </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link style={{border:"none"}} to={`#`} onClick={scrollTop}><span><img style={{height:"25px", width:'25px', marginRight:'5px',}} src="/images/icon/MicrosoftTeams-image (004).png" alt="" /></span>  Ruby </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link style={{border:"none"}} to={`#`} onClick={scrollTop}><span><img style={{height:"25px", width:'25px', marginRight:'5px',}} src="/images/icon/MicrosoftTeams-image (60).png" alt="" /></span> React Native </Link>
                      
                    </li>
                    <li  className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link style={{border:"none"}}  to={`#`} onClick={scrollTop}><span><img style={{height:"25px", width:'25px', marginRight:'5px',}} src="/images/icon/MicrosoftTeams-image (4Java).png" alt="" /></span> Java</Link>
                    </li>
                      </div>
                      <div className="col-4">
                      <li className={currentRoute === "/service" ? "sub-item active" : "sub-item"}>
                      <Link to={`#`} onClick={scrollTop}>Front End Technologies</Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link style={{border:"none"}}  to={`#`} onClick={scrollTop}><span><img style={{height:"25px", width:'25px', marginRight:'5px',}} src="/images/icon/MicrosoftTeams-image (60).png" alt="" /></span>REACT JS</Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link style={{border:"none"}} to={`#`} onClick={scrollTop}><span>  <img style={{height:"25px", width:'25px', marginRight:'5px',}} src="/images/icon/MicrosoftTeams-image (70).png" alt="" /></span> Angular </Link>

                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link style={{border:"none"}} to={`#`} onClick={scrollTop}><span>  <img style={{height:"25px", width:'25px', marginRight:'5px',}} src="/images/icon/MicrosoftTeams-image (400).png" alt="" /></span> Vue JS </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link style={{border:"none"}} to={`#`} onClick={scrollTop}><span>  <img style={{height:"25px", width:'25px', marginRight:'5px',}} src="/images/icon/MicrosoftTeams-image (60).png" alt="" /></span> IOS </Link>
                      {/* MicrosoftTeams-image (5).png */}
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link style={{border:"none"}} to={`#`} onClick={scrollTop}><span>  <img style={{height:"25px", width:'25px', marginRight:'5px',}} src="/images/icon/MicrosoftTeams-image (60).png" alt="" /></span> React Native </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link style={{border:"none"}} to={`#`} onClick={scrollTop}><span>  <img style={{height:"25px", width:'25px', marginRight:'5px',}} src="/images/icon/flutter.svg" alt="" /></span> Flutter </Link>
                    </li>
                      </div>
                      <div className="col-4">
                      <li className={currentRoute === "/service" ? "sub-item active" : "sub-item"}>
                      <Link  to={`${process.env.PUBLIC_URL}/service`} onClick={scrollTop}>Framework</Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link style={{border:"none"}} to={`#`} onClick={scrollTop}>Full Stack </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link style={{border:"none"}} to={`#`} onClick={scrollTop}> Firebase </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link style={{border:"none"}} to={`#`} onClick={scrollTop}> .Net </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link style={{border:"none"}} to={`/hire-mern-stack-developers`} onClick={scrollTop}> MERN </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link style={{border:"none"}} to={`#`} onClick={scrollTop}> MEAN </Link>
                    </li>
                    <li className={currentRoute === "/service-details" ? "sub-item active" : "sub-item"}>
                      <Link style={{border:"none"}} to={`#`} onClick={scrollTop}> Rails </Link>
                    </li>
                      </div>
                    </div>


                  </ul>
                </li>

                {/* <li className={currentRoute === "/blog-details" || currentRoute === "/blog-sidebar" || currentRoute === "/blog-grid" ? "menu-item active" : "menu-item"} onClick={() => dispatch({ type: 'blogs' })}>
                  <Link to={"#"} className="menu-link drop-down">
                    blog
                    <i className="bx bx-chevron-down dropdown-icon" />
                  </Link>
                  <ul className={
                    state.activeMenu === 'blogs'
                      ? "submenu d-block"
                      : "submenu d-xl-block d-none"
                  }>
                    <li className={currentRoute === "/blog-grid" ? "sub-item active" : "sub-item"}>
                      <NavLink onClick={scrollTop} to={`${process.env.PUBLIC_URL}/blog-grid`}>blog grid</NavLink>
                    </li>
                    <li className={currentRoute === "/blog-sidebar" ? "sub-item active" : "sub-item"}>
                      <NavLink onClick={scrollTop} to={`${process.env.PUBLIC_URL}/blog-sidebar`}>Blog sidebar</NavLink>
                    </li>
                    <li className={currentRoute === "/blog-details" ? "sub-item active" : "sub-item"}>
                      <NavLink onClick={scrollTop} to={`${process.env.PUBLIC_URL}/blog-details`}>Blog details</NavLink>
                    </li>
                  </ul>
                </li> */}
                {/* <li className={currentRoute === "/team" || currentRoute === "/feedback" || currentRoute === "/error" ? "menu-item active" : "menu-item"} onClick={() => dispatch({ type: 'pages' })}>
                  <Link to={"#"} className="menu-link drop-down">
                    Pages
                    <i className="bx bx-chevron-down dropdown-icon" />
                  </Link>
                  <ul className={
                    state.activeMenu === 'pages'
                      ? "submenu d-block"
                      : "submenu d-xl-block d-none"
                  }>
                    <li className={currentRoute === "/team" ? "sub-item active" : "sub-item"}>
                      <NavLink onClick={scrollTop} to={`${process.env.PUBLIC_URL}/team`}>team</NavLink>
                    </li>
                    <li className={currentRoute === "/feedback" ? "sub-item active" : "sub-item"}>
                      <Link onClick={scrollTop} to={`${process.env.PUBLIC_URL}/feedback`}>feedback</Link>
                    </li>
                    <li className={currentRoute === "/faq" ? "sub-item active" : "sub-item"}>
                      <Link onClick={scrollTop} to={`${process.env.PUBLIC_URL}/faq`} >faq</Link>
                    </li>
                    <li className={currentRoute === "/error" ? "sub-item active" : "sub-item"}>
                      <Link onClick={scrollTop} to={`${process.env.PUBLIC_URL}/error`}>Error-404</Link>
                    </li>
                  </ul>
                </li> */}

                {/* about */}
                <li className={currentRoute === "/about-us" ? "menu-item active" : "menu-item"}>
                  <Link onClick={scrollTop} to={`${process.env.PUBLIC_URL}/about-us`} className="menu-link">
                    ABOUT US
                  </Link>
                </li>


                {/* Contact */}
                <li className={currentRoute === "/contact-us" ? "menu-item active" : "menu-item"}>
                  <Link onClick={scrollTop} to={`${process.env.PUBLIC_URL}/contact-us`} className="menu-link">
                    CONTACT
                  </Link>
                </li>
              </ul>
              {/* mobile-search-area */}
              <div className="mobile-menu-bottom d-lg-none d-block">
                <Link to={"#"} className="mobile-menu-button eg-btn">
                  Start Project
                </Link>
                <ul className="header-social">
                  <li>
                    <a rel="noopener noreferrer" href="https://www.facebook.com/" target="_blank">FB</a>
                  </li>
                  <li>
                    <a rel="noopener noreferrer" href="https://www.twitter.com/" target="_blank">TW</a>
                  </li>
                  <li>
                    <a rel="noopener noreferrer" href="https://www.Linkedin.com/" target="_blank">IN</a>
                  </li>
                  <li>
                    <a rel="noopener noreferrer" href="https://www.pinterest.com/" target="_blank">PR</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="nav-right-area">
              <Link
                to={`${process.env.PUBLIC_URL}/contact-us`}
                onClick={scrollTop}
                className="eg-btn header-button hover-btn"
              >
                <span>Start Project</span>
              </Link>
{/*           
              <div onClick={handleSearchbar} className="search-icon-header search-btn">
                <i className="bx bx-search-alt-2" />
              </div> */}
              <div onClick={showSidebarleft} className="sidebar-header menu-sidebar-btn">
                <i className="bx bx-menu-alt-left" />
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
